export const categories = [
  { key: "all", name: "全部" },
  { key: "inside", name: "深挖内幕" },
  { key: "truth", name: "背后真相" },
  { key: "clue", name: "独家线索" },
  { key: "analysis", name: "深层解析" },
];

export const hotList = [
  { rank: 1, title: "同一件事的三层打开方式：热度之下那层被你错过", tag: "背后真相", heat: 128, delta: "持续升温" },
  { rank: 2, title: "从一份公开财报倒推，藏着的三步资本动作", tag: "独家线索", heat: 96, delta: "今日新增" },
  { rank: 3, title: "『爆款叙事』的供应链流水线是怎么运转的", tag: "深挖内幕", heat: 84, delta: "编辑部深读" },
  { rank: 4, title: "关系图谱拆解：同一张牌桌上的四个玩家", tag: "深层解析", heat: 71, delta: "专题更新" },
  { rank: 5, title: "流量退潮期，谁在悄悄调整姿势", tag: "背后真相", heat: 63, delta: "持续升温" },
];

export interface ArticleItem {
  id: number;
  category: string;
  categoryName: string;
  title: string;
  excerpt: string;
  time: string;
  readMinutes: number;
  author: string;
  tag: string;
  image: string;
}

export const articles: ArticleItem[] = [
  {
    id: 1,
    category: "inside",
    categoryName: "深挖内幕",
    title: "『爆款叙事』的流水线：一次热搜背后到底叠了几层料",
    excerpt: "当某类故事反复以相同结构出现，通常不是偶然，而是一条被反复验证过的生产线。我们从公开节点反推，梳理热度背后被藏起来的那几层。",
    time: "2026-09-03",
    readMinutes: 9,
    author: "看料·编辑部",
    tag: "行业纵深",
    image: "https://readdy.ai/api/search-image?query=Editorial%20investigative%20journalism%20still%20life%20of%20stacked%20printed%20newspapers%20and%20torn%20paper%20edges%20on%20a%20dark%20warm%20table%2C%20moody%20cinematic%20lighting%2C%20deep%20vermillion%20and%20amber%20accents%2C%20textured%20paper%20grain%2C%20depth%20of%20field%2C%20no%20people%2C%20high%20contrast%20documentary%20photography%20style&width=900&height=640&seq=kanliao-art-01&orientation=landscape",
  },
  {
    id: 2,
    category: "truth",
    categoryName: "背后真相",
    title: "你看懂的那层，和没看懂的那层：同一件事的三种打开方式",
    excerpt: "同一个热点，围观者、参与者和操盘者看到的是完全不同的世界。我们试着把三个视角并排摆开，找出理解这类信息的关键分岔点。",
    time: "2026-09-04",
    readMinutes: 7,
    author: "看料·夜班",
    tag: "认知拆解",
    image: "https://readdy.ai/api/search-image?query=Moody%20editorial%20concept%20photo%20of%20overlapping%20translucent%20documents%20and%20torn%20paper%20layers%20casting%20warm%20shadows%2C%20investigative%20news%20atmosphere%2C%20dark%20walnut%20desk%2C%20amber%20and%20ink%20tones%2C%20cinematic%20side%20light%2C%20textured%20grain%2C%20abstract%20documentary%20style%20without%20people&width=900&height=640&seq=kanliao-art-02&orientation=landscape",
  },
  {
    id: 3,
    category: "clue",
    categoryName: "独家线索",
    title: "一条被忽略的时间戳：从公开财报倒推三步资本动作",
    excerpt: "数字本身不会说谎，会说谎的是看图的人。按时间戳重新排序几条公开信息后，原本零散的动作连成了一条可以解释的逻辑线。",
    time: "2026-09-02",
    readMinutes: 11,
    author: "看料·线人组",
    tag: "数据还原",
    image: "https://readdy.ai/api/search-image?query=Close%20up%20of%20financial%20spreadsheets%20and%20printed%20charts%20being%20annotated%20with%20a%20red%20pen%20on%20dark%20wooden%20surface%2C%20investigative%20editorial%20mood%2C%20warm%20amber%20desk%20lamp%20light%2C%20paper%20texture%2C%20high%20contrast%2C%20cinematic%2C%20no%20people%2C%20documentary%20style&width=900&height=640&seq=kanliao-art-03&orientation=landscape",
  },
  {
    id: 4,
    category: "analysis",
    categoryName: "深层解析",
    title: "关系图谱拆解：同一张牌桌上的四个玩家各怀什么目的",
    excerpt: "表面上看是甲乙双方的博弈，放回关系网里才发现，真正决定走向的往往是站在桌边的第三方。一张图把复杂的利益关系摊平给你看。",
    time: "2026-09-05",
    readMinutes: 8,
    author: "看料·研究室",
    tag: "图谱专题",
    image: "https://readdy.ai/api/search-image?query=Abstract%20investigative%20network%20diagram%20of%20connected%20nodes%20and%20lines%20over%20dark%20textured%20paper%2C%20editorial%20data%20visualization%20aesthetic%2C%20warm%20ink%20and%20amber%20palette%20with%20deep%20red%20highlights%2C%20soft%20cinematic%20glow%2C%20no%20people%2C%20minimalist%20high%20contrast%20composition&width=900&height=640&seq=kanliao-art-04&orientation=landscape",
  },
  {
    id: 5,
    category: "inside",
    categoryName: "深挖内幕",
    title: "藏在工商变更里的『换血』信号：看懂几条关键字段",
    excerpt: "公司信息变更往往是最诚实的公开档案。股权、法人、注册资本的数字变化背后，通常意味着一次不为人知的方向调整，读懂它们有章可循。",
    time: "2026-08-29",
    readMinutes: 6,
    author: "看料·夜班",
    tag: "档案拆读",
    image: "https://readdy.ai/api/search-image?query=Stack%20of%20official%20registration%20documents%20and%20stamps%20on%20a%20worn%20wooden%20desk%2C%20warm%20dim%20editorial%20lighting%2C%20deep%20amber%20and%20dark%20ink%20palette%2C%20paper%20grain%20texture%2C%20investigative%20archive%20mood%2C%20cinematic%20shallow%20depth%2C%20no%20people%2C%20documentary%20style&width=900&height=640&seq=kanliao-art-05&orientation=landscape",
  },
  {
    id: 6,
    category: "truth",
    categoryName: "背后真相",
    title: "流量造星的退潮期，谁在悄悄调整『补货』姿势",
    excerpt: "当『一夜爆红』的叙事开始失灵，产业链不会消失，只会换一种更隐蔽的打法。我们梳理了退潮期里的几种典型姿势与信号。",
    time: "2026-08-27",
    readMinutes: 10,
    author: "看料·编辑部",
    tag: "行业观察",
    image: "https://readdy.ai/api/search-image?query=Moody%20editorial%20photo%20of%20scattered%20playing%20cards%20and%20a%20magnifying%20glass%20on%20dark%20textured%20fabric%2C%20warm%20amber%20and%20deep%20red%20lighting%2C%20investigative%20mood%2C%20paper%20grain%2C%20cinematic%20documentary%20still%20life%2C%20no%20people%2C%20high%20contrast%20composition&width=900&height=640&seq=kanliao-art-06&orientation=landscape",
  },
  {
    id: 7,
    category: "clue",
    categoryName: "独家线索",
    title: "一篇通稿之外：三处容易被忽略的『留白』",
    excerpt: "真正有用的信息往往不在正文里，而在那些刻意留白、一笔带过或语焉不详的位置。把留白标出来，常常比读完通稿收获更大。",
    time: "2026-08-25",
    readMinutes: 5,
    author: "看料·线人组",
    tag: "阅读术",
    image: "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20page%20with%20marked%20margins%20and%20highlighted%20paragraphs%20using%20warm%20paper%20tones%2C%20investigative%20editorial%20reading%20desk%20scene%2C%20amber%20side%20lighting%2C%20dark%20background%2C%20textured%20paper%2C%20cinematic%20shallow%20depth%2C%20no%20people%2C%20documentary%20style&width=900&height=640&seq=kanliao-art-07&orientation=landscape",
  },
  {
    id: 8,
    category: "analysis",
    categoryName: "深层解析",
    title: "方法论：五分钟从公开信息里找出那个关键节点",
    excerpt: "不必等内幕，也无需特殊渠道。多数线索就藏在已经公开的信息里，只是没人把它们串起来。这里整理了一套人人都能上手的排查顺序。",
    time: "2026-08-22",
    readMinutes: 12,
    author: "看料·研究室",
    tag: "方法拆解",
    image: "https://readdy.ai/api/search-image?query=Editorial%20flatlay%20of%20notebook%20with%20hand%20drawn%20arrows%2C%20timeline%20sketches%20and%20sticky%20notes%20on%20dark%20wooden%20desk%2C%20warm%20amber%20investigative%20workshop%20mood%2C%20ink%20and%20deep%20red%20accents%2C%20paper%20texture%2C%20cinematic%20lighting%2C%20no%20people%2C%20documentary%20composition&width=900&height=640&seq=kanliao-art-08&orientation=landscape",
  },
];

export const timeline = [
  {
    date: "2026-09-05",
    title: "图谱专题更新：四个玩家的利益线首次摊平",
    desc: "把零散的动作连成一条可解释的路径，更新关系图谱主线。",
  },
  {
    date: "2026-09-02",
    title: "从公开财报还原三步资本动作",
    desc: "按时间戳重排公开数据，推出独家线索系列第二篇。",
  },
  {
    date: "2026-08-28",
    title: "『爆款叙事』流水线深读上线",
    desc: "编辑部用两周交叉核对公开节点，梳理出五层结构。",
  },
  {
    date: "2026-08-20",
    title: "「深层解析」栏目方法论上线",
    desc: "确立『先看留白、再看节点、最后连线』的拆解框架。",
  },
  {
    date: "2026-08-12",
    title: "看料网正式对外：把被折叠的部分翻出来",
    desc: "聚焦内幕挖掘与真相梳理，坚持只对公开信息做结构化拆解。",
  },
];

export const clues = [
  {
    level: "A",
    levelName: "高置信",
    color: "primary",
    title: "某平台『换血』信号已出现",
    desc: "多条公开工商变更同步指向管理层与股权结构的集中调整，方向明确但尚未官宣。",
    status: "跟进中",
  },
  {
    level: "B",
    levelName: "需验证",
    color: "accent",
    title: "一份时间戳前后矛盾的通稿",
    desc: "正文时间线与留白之间存在冲突，编辑部正在交叉核对原始出处。",
    status: "核实中",
  },
  {
    level: "B",
    levelName: "需验证",
    color: "accent",
    title: "疑似『补货』节奏的异常投放",
    desc: "退潮期出现逆势投放样本，样本量偏小，暂不作结论。",
    status: "观察中",
  },
  {
    level: "C",
    levelName: "线索池",
    color: "secondary",
    title: "关系网中的边缘节点待补全",
    desc: "图谱第三环存在信息缺口，欢迎读者用公开资料补充连线。",
    status: "开放征集",
  },
];

export const principles = [
  {
    key: "01",
    title: "只拆公开信息",
    desc: "不追踪隐私，不搬运未经核实的内容。所有拆解都建立在公开档案、公告与一手材料之上，讲清楚『依据是什么』。",
  },
  {
    key: "02",
    title: "把留白讲明白",
    desc: "深度不等于阴谋论。我们把被刻意折叠的结构摊开，也如实标注哪些是推断、哪些待验证，留白处绝不补脑补故事。",
  },
  {
    key: "03",
    title: "结构大于情绪",
    desc: "比起煽动，我们更在意关系与因果。同一件事给出多视角与时间线，让读者自己完成判断，而不是替读者下结论。",
  },
];

export const testimonials = [
  { quote: "看料网把很多我以为早该看懂的事，重新讲清楚了一层。", name: "深度读者 · 北京" },
  { quote: "关系图谱那几期很实在，逻辑链摆得明明白白，不是标题党。", name: "行业从业者" },
  { quote: "从留白里找信息那一篇，改变了我读通稿的习惯。", name: "媒体新人 · 上海" },
];

export const faqs = [
  {
    q: "看料网的内容从哪里来？",
    a: "看料网聚焦深挖内幕与背后真相，但全部拆解均以公开信息为基础，包括财报、公告、工商档案、公开报道与可交叉核对的时间戳。我们只对已公开的结构做重新梳理与解读，不涉及个人隐私与未核实的传闻。",
  },
  {
    q: "为什么有些选题标注『需验证』？",
    a: "编辑部把内容分为高置信、需验证与线索池三级。凡证据链尚不完整、只存在方向性信号的内容，都会明确标注状态并持续跟进，绝不把推断当作既成事实呈现。",
  },
  {
    q: "我也有线索或资料，可以投稿吗？",
    a: "欢迎。你可以通过页面底部的『线索投稿』提交公开资料线索或选题建议。请在投稿时附上可交叉核对的原始出处，编辑部会依据公开信息复核后决定是否跟进。",
  },
  {
    q: "网站内容多久更新一次？",
    a: "真相档案与深层解析以栏目节奏更新，热点追踪随事件推进滚动刷新。你还可以订阅看料网，第一时间收到头条深读与档案更新的通知。",
  },
];